import { useEffect } from 'react';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { fetchAgencyDetail, updateAgencyDetail } from 'store/agency';
import { Agency, AgencyStatus } from 'model/agency';
import _ from 'lodash';
import { activeAccountType } from 'common/const';
import { message } from '@tencent/spaui';

export interface AgencyDetailProps {
  data: Agency;
  onUpdate: (data: Agency) => Promise<any>;
}

const useAgencyDetail = () => {
  const dispatch = useAppDispatch();
  const { user } = useTypedSelector((state) => state.user);
  const dataInfo = useTypedSelector((state) => state.agency?.agencyDetail || {});
  const loading = useTypedSelector((state) => state.agency?.agencyDetailLoading);

  useEffect(() => {
    if (_.isEmpty(dataInfo) && user?.active_account_type === activeAccountType.isvAgency) {
      dispatch(fetchAgencyDetail());
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [user?.active_account_type]);

  const onUpdate = async (data: { authorize_file: any }): Promise<any> => {
    const res = await dispatch(updateAgencyDetail(data));
    const isSuccess = res.meta.requestStatus === 'fulfilled';
    if (isSuccess) {
      let msg = '更新信息成功';
      if (dataInfo.status === AgencyStatus.reject) {
        msg = '更新资料提交成功，资料进入待审核状态';
      }
      message.success(msg);
      const container = document.querySelector('#managePageContainer');
      container?.scrollTo(0, 0);
      setTimeout(() => {
        dispatch(fetchAgencyDetail());
      }, 2000);
    }
    return isSuccess;
  };

  return {
    data: dataInfo,
    loading,
    onUpdate,
  };
};

export default useAgencyDetail;
